import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Gift, Star, Clock, Shield } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const LeadMagnetCTA = () => {
  const navigate = useNavigate();
  
  const handleGetFreeDisc = () => {
    navigate("/disque-gratuit");
  };
  return <section className="py-20 bg-gradient-to-br from-orange-50 to-orange-100">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Badge d'offre spéciale */}
          <div className="text-center mb-8">
            <div className="inline-block bg-orange-500 text-white px-6 py-2 rounded-full text-sm font-bold mb-4">
              🎯 OFFRE EXCLUSIVE - CODE: BIENVENUE
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Recevez Votre <span className="text-orange-500">Disque Gratuit</span>
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Testez l'Elite Precision sans engagement et découvrez pourquoi +5000 professionnels nous font confiance
            </p>
          </div>

          {/* Carte principale */}
          <Card className="bg-white shadow-2xl border-0 overflow-hidden">
            <CardContent className="p-0">
              <div className="grid lg:grid-cols-2 gap-0">
                {/* Image du produit */}
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-8 flex items-center justify-center">
                  <div className="relative">
                    <img src="https://static-us-img.skywork.ai/prod/user/head_picture/1983116284937027584_SLF30 Ø125 ELITE Précision.jpg?image_process=quality,q_90/resize,w_1280/format,webp" alt="Disque Elite Precision Gratuit" className="w-80 rounded-2xl shadow-lg sk-edit-loading h-[320px] object-cover" />
                    <div className="absolute -top-4 -right-4 bg-orange-500 text-white rounded-full p-3">
                      <Gift className="h-6 w-6" />
                    </div>
                  </div>
                </div>

                {/* Contenu */}
                <div className="p-8 lg:p-12">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">
                    Pourquoi Elite Precision ?
                  </h3>
                  
                  <div className="space-y-4 mb-8">
                    <div className="flex items-start space-x-3">
                      <Star className="h-5 w-5 text-orange-500 mt-1 flex-shrink-0" />
                      <div>
                        <div className="font-semibold text-gray-900">Précision Chirurgicale</div>
                        <div className="text-gray-600 text-sm">Coupe ultra-précise même sur grès cérame pleine masse</div>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <Clock className="h-5 w-5 text-orange-500 mt-1 flex-shrink-0" />
                      <div>
                        <div className="font-semibold text-gray-900">Vitesse Turbo</div>
                        <div className="text-gray-600 text-sm">Segments superthin 1,4mm pour une coupe 2x plus rapide</div>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <Shield className="h-5 w-5 text-orange-500 mt-1 flex-shrink-0" />
                      <div>
                        <div className="font-semibold text-gray-900">Durée de Vie Doublée</div>
                        <div className="text-gray-600 text-sm">Résistance 2x supérieure aux disques standards</div>
                      </div>
                    </div>
                  </div>

                  <Button onClick={handleGetFreeDisc} className="w-full bg-orange-500 hover:bg-orange-600 text-white text-lg py-6 rounded-xl font-bold shadow-lg hover:shadow-xl transition-all duration-300">
                    🎁 RECEVOIR MON DISQUE GRATUIT
                  </Button>

                  <div className="mt-4 text-center">
                    <p className="text-sm text-gray-500">
                      ✅ Livraison gratuite • ✅ Sans engagement • ✅ Essai 30 jours
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Badges de confiance */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 text-center">
            <div className="bg-white rounded-lg p-4 shadow-md">
              <div className="text-2xl font-bold text-orange-500">+5000</div>
              <div className="text-sm text-gray-600">Professionnels</div>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-md">
              <div className="text-2xl font-bold text-orange-500">96%</div>
              <div className="text-sm text-gray-600">Satisfaction</div>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-md">
              <div className="text-2xl font-bold text-orange-500">20+</div>
              <div className="text-sm text-gray-600">Ans d'expertise</div>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-md">
              <div className="text-2xl font-bold text-orange-500">100k+</div>
              <div className="text-sm text-gray-600">Disques vendus</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};